import { canv } from "@/canv/global";
import { Shape } from "../shape";

export class ShapeRequiredInterface extends Shape {
    width = 160;
    height = 200;

    needFill = false;
    includeText = false;

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();

        const rw = w * 0.625;
        const rh = h * 0.5;

        canv.ctx.moveTo(x, y);

        canv.ctx.ellipse(x, y + h / 2, rw, rh, 0, Math.PI * 1.5, Math.PI * 0.5);

        canv.ctx.moveTo(x + rw, y + h / 2);
        canv.ctx.lineTo(x + w, y + h / 2);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="${stroke}" d="M14.2 12A10 10 0 0 1 4 22m10.2-10A10 10 0 0 0 4 2m10.2 10H20"/>
            </svg>
        `;
    }
}
